import { connect } from 'react-redux';

import { dispatchify } from 'common/utils/utils';
import { resetPullRequests } from 'state/callers';
import Activity from './Activity';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    ...dispatchify(dispatch, {
      resetPullRequests
    })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Activity, 'Activity'));
